import { render } from "./Assistant.vue?vue&type=template&id=6bd1cf0a&scoped=true"
import script from "./Assistant.vue?vue&type=script&lang=ts"
export * from "./Assistant.vue?vue&type=script&lang=ts"

import "./Assistant.vue?vue&type=style&index=0&id=6bd1cf0a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6bd1cf0a"

export default script